// import { useState, useEffect } from "react";
// import { db } from "../../../firebase";
// import { collection, getDocs } from "firebase/firestore";
// import Header from "../../layout/Header";
// import Footer from "../../layout/Footer";
// import { useNavigate } from "react-router-dom";

// const MachinesPage = () => {
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [machines, setMachines] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadCategories();
//   }, []);

//   const loadCategories = async () => {
//     try {
//       const snapshot = await getDocs(collection(db, "categories"));
//       const categoriesData = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setCategories(categoriesData);
//       if (categoriesData.length > 0) {
//         setSelectedCategory(categoriesData[0].id);
//       }
//     } catch (error) {
//       console.error("Error loading categories:", error);
//     }
//   };

//   useEffect(() => {
//     if (selectedCategory) {
//       loadMachines(selectedCategory);
//     }
//   }, [selectedCategory]);

//   const loadMachines = async (categoryId) => {
//     setLoading(true);
//     try {
//       const snapshot = await getDocs(
//         collection(db, "categories", categoryId, "machines"),
//       );
//       const machinesData = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setMachines(machinesData);
//       console.log(snapshot,+"xxxxxxxxxxxxxxxxxxxxxx");

//     } catch (error) {
//       console.error("Error loading machines:", error);
//     }
//     setLoading(false);
//   };

//   const getCategoryName = (categoryId) => {
//     return categories.find((cat) => cat.id === categoryId)?.name || "Category";
//   };
//   const navigate = useNavigate();

//   const handleContact = () => navigate("/contact");
//    // Open machine details page
//    const handleMachineClick = (machineId) => {
//     navigate(`/MachineDetails/${selectedCategory}/${machineId}`);
//   };

//   return (
//     <>
//       <Header />
//       <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50/30">
//         <div className="relative overflow-hidden bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900 text-white py-40">
//           <div className="absolute inset-0 bg-black/20"></div>
//           <div className="relative max-w-7xl mx-auto px-4 text-center">
//             <h1 className="text-5xl md:text-6xl font-black mb-6 bg-gradient-to-r from-white to-blue-100 bg-clip-text text-transparent">
//               Machinery Collection
//             </h1>
//             <p className="text-xl text-blue-100 max-w-2xl mx-auto leading-relaxed">
//               Premium industrial equipment engineered for precision and
//               performance
//             </p>
//             <div className="w-24 h-1 bg-blue-400 mx-auto mt-8 rounded-full"></div>
//           </div>
//         </div>
//         <div className="max-w-7xl mx-auto px-4 py-12 -mt-10 relative z-10">
//           <div className="bg-white/80 backdrop-blur-sm rounded-3xl border border-white/20 shadow-2xl shadow-blue-500/5 p-8 mb-12">
//             <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
//               <div className="flex items-center gap-4 flex-1">
//                 <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center">
//                   <span className="text-white text-lg">⚙️</span>
//                 </div>
//                 <div className="flex-1">
//                   <label className="block text-sm font-semibold text-slate-500 uppercase tracking-wide mb-2">
//                     Filter Machinery
//                   </label>
//                   <div className="relative">
//                     <select
//                       value={selectedCategory}
//                       onChange={(e) => setSelectedCategory(e.target.value)}
//                       className="w-full bg-white/80 backdrop-blur-sm border-2 border-slate-200 rounded-2xl px-6 py-4 text-xl font-bold text-slate-800 focus:border-blue-500 focus:ring-4 focus:ring-blue-500/20 transition-all duration-300 cursor-pointer appearance-none shadow-lg hover:shadow-xl hover:border-blue-400"
//                     >
//                       {categories.map((category) => (
//                         <option key={category.id} value={category.id}>
//                           {category.name}
//                         </option>
//                       ))}
//                     </select>
//                     <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
//                       <svg
//                         className="w-6 h-6 text-slate-400"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M19 9l-7 7-7-7"
//                         />
//                       </svg>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-3 rounded-2xl font-bold text-lg shadow-lg shadow-blue-500/25">
//                 {machines.length} {machines.length === 1 ? "Unit" : "Units"}{" "}
//                 Available
//               </div>
//             </div>
//           </div>
//           {loading && (
//             <div className="flex flex-col items-center justify-center py-20">
//               <div className="relative">
//                 <div className="w-16 h-16 border-4 border-blue-200 rounded-full animate-spin"></div>
//                 <div className="w-16 h-16 border-4 border-transparent border-t-blue-500 rounded-full animate-spin absolute top-0 left-0"></div>
//               </div>
//               <p className="text-slate-500 mt-4 font-medium">
//                 Loading machinery...
//               </p>
//             </div>
//           )}
//           {!loading && machines.length === 0 && (
//             <div className="text-center py-20">
//               <div className="w-32 h-32 bg-gradient-to-br from-slate-100 to-blue-100 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-lg">
//                 <span className="text-6xl">🔍</span>
//               </div>
//               <h3 className="text-3xl font-bold text-slate-800 mb-3">
//                 No Machinery Found
//               </h3>
//               <p className="text-slate-600 text-lg max-w-md mx-auto">
//                 No machines available in{" "}
//                 <span className="font-semibold text-blue-600">
//                   "{getCategoryName(selectedCategory)}"
//                 </span>{" "}
//                 category yet.
//               </p>
//             </div>
//           )}
//           {!loading && machines.length > 0 && (
//             <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
//               {machines.map((machine, index) => (
//                 <div
//                   key={machine.id}
//                   onClick={() => handleMachineClick(machine.id)}
//                   className="group relative bg-white rounded-3xl shadow-lg shadow-slate-200/50 hover:shadow-2xl hover:shadow-blue-500/10 border border-slate-100 overflow-hidden transition-all duration-500 hover:-translate-y-2"
//                 >
//                   {/* <div className="relative overflow-hidden bg-slate-100">
//                   {machine.image ? (
//                     <img
//                       src={machine.image}
//                       alt={machine.name}
//                       className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110"
//                     />
//                   ) : (
//                     <div className="w-full h-64 bg-gradient-to-br from-slate-200 to-slate-300 flex items-center justify-center">
//                       <span className="text-4xl text-slate-400">🏭</span>
//                     </div>
//                   )}
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//                   <div className="absolute top-4 left-4">
//                     <span className="bg-white/90 backdrop-blur-sm text-slate-700 text-sm font-semibold px-3 py-2 rounded-2xl shadow-lg">
//                       {getCategoryName(selectedCategory)}
//                     </span>
//                   </div>
//                 </div> */}
//                   <div className="relative overflow-hidden bg-slate-100">
//                     {machine.image ? (
//                       <img
//                         src={machine.image}
//                         alt={machine.name}
//                         className="w-full h-64 object-contain transition-transform duration-700"
//                       />
//                     ) : (
//                       <div className="w-full h-64 bg-gradient-to-br from-slate-200 to-slate-300 flex items-center justify-center">
//                         <span className="text-4xl text-slate-400">🏭</span>
//                       </div>
//                     )}

//                     <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

//                     <div className="absolute top-4 left-4">
//                       <span className="bg-white/90 backdrop-blur-sm text-slate-700 text-sm font-semibold px-3 py-2 rounded-2xl shadow-lg">
//                         {getCategoryName(selectedCategory)}
//                       </span>
//                     </div>
//                   </div>
//                   <div className="p-6">
//                     <h3 className="text-xl font-bold text-slate-800 mb-3 line-clamp-2 group-hover:text-blue-600 transition-colors">
//                       {machine.name}
//                     </h3>
//                     {machine.description && (
//                       <p className="text-slate-600 mb-4 line-clamp-3 leading-relaxed">
//                         {machine.description}
//                       </p>
//                     )}
//                     {machine.specification && (
//                       <div className="mb-4">
//                         <div className="flex items-center gap-2 mb-2">
//                           <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
//                           <h4 className="font-semibold text-slate-700 text-sm">
//                             KEY SPECS
//                           </h4>
//                         </div>
//                         <p className="text-slate-600 text-sm line-clamp-2">
//                           {machine.specification}
//                         </p>
//                       </div>
//                     )}
//                     <div className="flex gap-3 pt-4 border-t border-slate-100">
//                       {machine.pdf && (
//                         <a
//                           href={machine.pdf}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-center py-3 px-4 rounded-2xl font-semibold hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-300 transform hover:scale-105 active:scale-95"
//                         >
//                           📄 Download Specs
//                         </a>
//                       )}
//                       <button
//                         onClick={handleContact}
//                         className="flex-1 border-2 border-slate-200 text-slate-700 text-center py-3 px-4 rounded-2xl font-semibold hover:border-blue-500 hover:text-blue-600 hover:bg-blue-50 transition-all duration-300"
//                       >
//                         💬 Inquiry
//                       </button>
//                     </div>
//                   </div>
//                   <div className="absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-blue-500/20 transition-all duration-500 pointer-events-none"></div>
//                 </div>
//               ))}
//             </div>
//           )}
//           {!loading && machines.length > 0 && (
//             <div className="text-center mt-16">
//               <div className="bg-gradient-to-r from-slate-900 to-blue-900 rounded-3xl p-8 text-white shadow-2xl">
//                 <h3 className="text-2xl font-bold mb-3">
//                   Need Custom Machinery?
//                 </h3>
//                 <p className="text-blue-100 mb-6 max-w-md mx-auto">
//                   We provide tailored solutions for your specific industrial
//                   requirements
//                 </p>
//                 <button
//                   onClick={handleContact}
//                   className="bg-white text-slate-900 px-8 py-4 rounded-2xl font-bold hover:bg-blue-50 transition-colors duration-300 shadow-lg"
//                 >
//                   📞 Contact Our Experts
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default MachinesPage;
import { useState, useEffect } from "react";
import { db } from "../../../firebase";
import { collection, getDocs } from "firebase/firestore";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useNavigate } from "react-router-dom";

const MachinesPage = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [machines, setMachines] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      const snapshot = await getDocs(collection(db, "categories"));

      const categoriesData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setCategories(categoriesData);

      if (categoriesData.length > 0) {
        setSelectedCategory(categoriesData[0].id);
      }
    } catch (error) {
      console.error("Error loading categories:", error);
    }
  };

  useEffect(() => {
    if (selectedCategory) {
      loadMachines(selectedCategory);
    }
  }, [selectedCategory]);

  const loadMachines = async (categoryId) => {
    setLoading(true);

    try {
      const snapshot = await getDocs(
        collection(db, "categories", categoryId, "machines"),
      );

      const machinesData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setMachines(machinesData);
    } catch (error) {
      console.error("Error loading machines:", error);
    }

    setLoading(false);
  };

  const getCategoryName = (categoryId) => {
    return categories.find((cat) => cat.id === categoryId)?.name || "Category";
  };

  const handleContact = () => navigate("/contact");

  const handleMachineClick = (machineId) => {
    navigate(`/MachineDetails/${selectedCategory}/${machineId}`);
  };

  return (
    <>
      <Header />

      <main className="min-h-screen bg-[#f6f9fc] relative overflow-hidden">
        {/* =====================================================
            BACKGROUND DECORATION
        ====================================================== */}

        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[350px] bg-blue-400/10 blur-[120px] rounded-full pointer-events-none" />

        <div className="absolute top-[700px] -left-40 w-[400px] h-[400px] bg-teal-400/5 blur-[100px] rounded-full pointer-events-none" />

        {/* =====================================================
            HERO
        ====================================================== */}

        {/* =====================================================
    COMPACT HERO
====================================================== */}

        <section className="relative pt-10 sm:pt-12 lg:pt-14 pb-20 sm:pb-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            {/* Small label */}
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white border border-slate-200 shadow-sm mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />

              <span className="text-[11px] font-bold tracking-[0.16em] uppercase text-slate-500">
                Industrial Equipment
              </span>
            </div>

            {/* Heading */}
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
              Machinery{" "}
              <span className="bg-gradient-to-r from-blue-600 to-teal-500 bg-clip-text text-transparent">
                Collection
              </span>
            </h1>

            {/* Description */}
            <p className="mt-4 max-w-2xl mx-auto text-sm sm:text-base text-slate-500 leading-6">
              Explore our range of precision industrial machinery engineered for
              reliability, performance and demanding applications.
            </p>

            {/* Accent */}
            <div className="mt-5 flex items-center justify-center gap-2">
              <div className="w-10 h-[2px] rounded-full bg-blue-600" />

              <div className="w-2.5 h-[2px] rounded-full bg-teal-500" />
            </div>
          </div>
        </section>

        {/* =====================================================
    MAIN CONTENT
====================================================== */}

        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 pb-16">
          {/* =================================================
      FILTER CARD
  ================================================= */}

          <div className="relative mb-10">
            {/* Glow */}
            <div className="absolute -inset-[1px] rounded-[24px] bg-gradient-to-r from-blue-400/25 via-white to-teal-400/25 blur-[2px]" />

            <div className="relative bg-white/95 backdrop-blur-xl rounded-[24px] border border-slate-200/80 shadow-[0_15px_45px_rgba(15,23,42,0.08)] p-5 sm:p-6">
              <div className="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-5">
                {/* Category */}

                <div className="flex items-center gap-4 flex-1">
                  {/* Icon */}

                  <div className="hidden sm:flex w-11 h-11 shrink-0 rounded-xl bg-blue-50 border border-blue-100 items-center justify-center">
                    <svg
                      className="w-5 h-5 text-blue-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.7"
                        d="M10.5 6.75h3M8.25 9.75h7.5M6.75 13.5h10.5M4.5 18.75h15"
                      />
                    </svg>
                  </div>

                  <div className="flex-1">
                    <label className="block text-[11px] font-bold text-slate-400 uppercase tracking-[0.15em] mb-1.5">
                      Select Category
                    </label>

                    <div className="relative">
                      <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        className="w-full appearance-none bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 pr-11 text-sm sm:text-base font-bold text-slate-800 outline-none cursor-pointer focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 transition-all duration-300"
                      >
                        {categories.map((category) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>

                      <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                        <svg
                          className="w-5 h-5 text-slate-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.8"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Units */}

                <div className="inline-flex items-center gap-3 self-start lg:self-center px-4 py-2.5 rounded-xl bg-slate-50 border border-slate-200">
                  <span className="w-2 h-2 rounded-full bg-emerald-500" />

                  <div>
                    <span className="text-base font-extrabold text-slate-900">
                      {machines.length}
                    </span>

                    <span className="ml-1.5 text-xs font-medium text-slate-500">
                      {machines.length === 1 ? "Unit" : "Units"} Available
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* =================================================
              LOADING
          ================================================= */}

          {loading && (
            <div className="flex flex-col items-center justify-center py-24">
              <div className="relative">
                <div className="absolute -inset-3 rounded-full bg-blue-400/10 blur-xl" />

                <div className="relative w-16 h-16 rounded-full bg-white border border-slate-200 shadow-lg flex items-center justify-center">
                  <div className="w-8 h-8 rounded-full border-[3px] border-blue-100 border-t-blue-600 animate-spin" />
                </div>
              </div>

              <p className="mt-6 text-sm font-medium text-slate-500">
                Loading machinery...
              </p>
            </div>
          )}

          {/* =================================================
              EMPTY STATE
          ================================================= */}

          {!loading && machines.length === 0 && (
            <div className="relative max-w-xl mx-auto">
              <div className="absolute -inset-[1px] rounded-[28px] bg-gradient-to-r from-blue-400/20 via-white to-teal-400/20 blur-[2px]" />

              <div className="relative bg-white rounded-[28px] border border-slate-200 shadow-[0_20px_60px_rgba(15,23,42,0.08)] p-10 sm:p-14 text-center">
                <div className="mx-auto w-20 h-20 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center">
                  <svg
                    className="w-9 h-9 text-slate-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.7"
                      d="M10.5 10.5L21 21m-6-10.5A4.5 4.5 0 1110.5 6a4.5 4.5 0 014.5 4.5z"
                    />
                  </svg>
                </div>

                <h3 className="mt-6 text-2xl font-bold text-slate-900">
                  No Machinery Found
                </h3>

                <p className="mt-3 text-slate-500 leading-7">
                  No machines are currently available in{" "}
                  <span className="font-semibold text-blue-600">
                    "{getCategoryName(selectedCategory)}"
                  </span>
                  .
                </p>
              </div>
            </div>
          )}

          {/* =================================================
              MACHINES GRID
          ================================================= */}

          {!loading && machines.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-7">
              {machines.map((machine) => (
                <article
                  key={machine.id}
                  className="group relative cursor-pointer"
                  onClick={() => handleMachineClick(machine.id)}
                >
                  {/* Card Glow */}

                  <div className="absolute -inset-[1px] rounded-[26px] bg-gradient-to-br from-blue-400/0 via-white to-teal-400/0 group-hover:from-blue-400/30 group-hover:to-teal-400/20 transition-all duration-500 blur-[1px]" />

                  {/* Card */}

                  <div className="relative h-full bg-white rounded-[26px] border border-slate-200/80 overflow-hidden shadow-[0_12px_35px_rgba(15,23,42,0.07)] group-hover:shadow-[0_25px_60px_rgba(15,23,42,0.12)] group-hover:-translate-y-1.5 transition-all duration-500">
                    {/* =========================
                        IMAGE
                    ========================== */}

                    <div className="relative h-[270px] overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50/30">
                      {/* Image glow */}

                      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-full bg-blue-400/10 blur-[60px]" />

                      {machine.image ? (
                        <img
                          src={machine.image}
                          alt={machine.name}
                          className="relative z-10 w-full h-full object-contain p-6 transition-transform duration-700 group-hover:scale-[1.04]"
                        />
                      ) : (
                        <div className="relative z-10 w-full h-full flex items-center justify-center">
                          <div className="w-20 h-20 rounded-full bg-white border border-slate-200 shadow-md flex items-center justify-center">
                            <svg
                              className="w-9 h-9 text-slate-300"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.5"
                                d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-5h6v5M9 9h.01M12 9h.01M15 9h.01M9 12h.01M12 12h.01M15 12h.01"
                              />
                            </svg>
                          </div>
                        </div>
                      )}

                      {/* Category */}

                      <div className="absolute top-4 left-4 z-20">
                        <span className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-md border border-slate-200 px-3 py-2 rounded-full shadow-sm">
                          <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />

                          <span className="text-[11px] font-bold text-slate-600 uppercase tracking-wide">
                            {getCategoryName(selectedCategory)}
                          </span>
                        </span>
                      </div>

                      {/* View Details */}

                      <div className="absolute bottom-4 right-4 z-20 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                        <span className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-slate-900 text-white text-xs font-semibold shadow-lg">
                          View Details
                          <span>→</span>
                        </span>
                      </div>
                    </div>

                    {/* =========================
                        CONTENT
                    ========================== */}

                    <div className="p-6">
                      {/* Machine Name */}

                      <h3 className="text-xl font-bold text-slate-900 leading-snug line-clamp-2 group-hover:text-blue-600 transition-colors duration-300">
                        {machine.name}
                      </h3>

                      {/* Description */}

                      {machine.description && (
                        <p className="mt-3 text-sm text-slate-500 leading-6 line-clamp-3">
                          {machine.description}
                        </p>
                      )}

                      {/* Specification */}

                      {machine.specification && (
                        <div className="mt-5">
                          <div className="flex items-center gap-2 mb-2.5">
                            <div className="w-1.5 h-1.5 rounded-full bg-blue-500" />

                            <h4 className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400">
                              Key Specifications
                            </h4>
                          </div>

                          <div className="bg-slate-50 rounded-xl border border-slate-100 px-4 py-3">
                            <p className="text-xs sm:text-sm text-slate-500 leading-6 line-clamp-2 whitespace-pre-line">
                              {machine.specification}
                            </p>
                          </div>
                        </div>
                      )}

                      {/* Divider */}

                      <div className="mt-5 pt-5 border-t border-slate-100">
                        <div className="flex gap-3">
                          {/* PDF */}

                          {machine.pdf && (
                            <a
                              href={machine.pdf}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                              className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-3 rounded-xl bg-slate-900 text-white text-xs sm:text-sm font-semibold hover:bg-blue-600 transition-all duration-300"
                            >
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="1.8"
                                  d="M12 3v12m0 0l4-4m-4 4l-4-4M5 21h14"
                                />
                              </svg>
                              Specs
                            </a>
                          )}

                          {/* Inquiry */}

                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleContact();
                            }}
                            className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-3 rounded-xl border border-slate-200 text-slate-700 text-xs sm:text-sm font-semibold hover:border-blue-500 hover:text-blue-600 hover:bg-blue-50 transition-all duration-300"
                          >
                            <svg
                              className="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.8"
                                d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"
                              />
                            </svg>
                            Inquiry
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}

          {/* =================================================
              CUSTOM MACHINERY CTA
          ================================================= */}

          {!loading && machines.length > 0 && (
            <div className="relative mt-16">
              {/* Glow */}

              <div className="absolute -inset-[1px] rounded-[28px] bg-gradient-to-r from-blue-500/30 via-white to-teal-500/30 blur-[2px]" />

              <div className="relative overflow-hidden rounded-[28px] bg-slate-900 px-7 py-10 sm:px-10 lg:px-14 lg:py-12">
                {/* Background glow */}

                <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full bg-blue-500/20 blur-[80px]" />

                <div className="absolute -left-20 -bottom-20 w-72 h-72 rounded-full bg-teal-500/10 blur-[80px]" />

                <div className="relative flex flex-col lg:flex-row items-center justify-between gap-8">
                  <div className="text-center lg:text-left">
                    <div className="inline-flex items-center gap-2 mb-4">
                      <span className="w-2 h-2 rounded-full bg-blue-400" />

                      <span className="text-xs font-bold tracking-[0.16em] uppercase text-blue-300">
                        Custom Solutions
                      </span>
                    </div>

                    <h3 className="text-2xl sm:text-3xl font-bold text-white">
                      Need Custom Machinery?
                    </h3>

                    <p className="mt-3 max-w-xl text-sm sm:text-base text-slate-400 leading-6">
                      We provide tailored industrial machinery solutions
                      designed around your specific requirements.
                    </p>
                  </div>

                  <button
                    onClick={handleContact}
                    className="shrink-0 inline-flex items-center gap-3 bg-white text-slate-900 px-6 sm:px-8 py-3.5 rounded-xl font-bold text-sm hover:bg-blue-50 transition-all duration-300 shadow-xl"
                  >
                    Contact Our Experts
                    <span className="text-blue-600 text-lg">→</span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </section>
      </main>

      <Footer />
    </>
  );
};

export default MachinesPage;
